 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"EN_About":"EN_About","EN_EditPost~EN_MyProfile~admin_content_editor~admin_sponsors~admin_users~app_protected_moj_profil~ap~9952ae35":"EN_EditPost~EN_MyProfile~admin_content_editor~admin_sponsors~admin_users~app_protected_moj_profil~ap~9952ae35","EN_EditPost~app_protected_zapis":"EN_EditPost~app_protected_zapis","EN_EditPost":"EN_EditPost","app_protected_zapis":"app_protected_zapis","EN_MyProfile":"EN_MyProfile","admin_content_editor":"admin_content_editor","admin_sponsors":"admin_sponsors","admin_users":"admin_users","app_protected_moj_profil":"app_protected_moj_profil","EN_Home":"EN_Home","EN_Instructions":"EN_Instructions","EN_MyPosts":"EN_MyPosts","EN_Post~zapis":"EN_Post~zapis","EN_Post":"EN_Post","zapis":"zapis","EN_Register~registracija":"EN_Register~registracija","EN_Register":"EN_Register","registracija":"registracija","EN_SignIn":"EN_SignIn","EN_TermsAndConditions":"EN_TermsAndConditions","Instructions":"Instructions","Vsa":"Vsa","admin":"admin","admin_nazorna_plosca":"admin_nazorna_plosca","app_protected":"app_protected","app_protected_moji_zapisi":"app_protected_moji_zapisi","o_projektu":"o_projektu","pogoji_uporabe":"pogoji_uporabe","prijava":"prijava"}[chunkId]||chunkId) + "." + {"EN_About":"6ab2e4ad","EN_EditPost~EN_MyProfile~admin_content_editor~admin_sponsors~admin_users~app_protected_moj_profil~ap~9952ae35":"372d552b","EN_EditPost~app_protected_zapis":"ec8ce7c4","EN_EditPost":"e8cff35f","app_protected_zapis":"de169e95","EN_MyProfile":"1f8d8c79","admin_content_editor":"7be624a7","admin_sponsors":"0eddb4c3","admin_users":"c87d58ea","app_protected_moj_profil":"71f4b7f0","EN_Home":"3d3835ad","EN_Instructions":"0825158c","EN_MyPosts":"3d3edfd9","EN_Post~zapis":"e4b9d3de","EN_Post":"9e39b9a8","zapis":"4aa1be38","EN_Register~registracija":"053d89f7","EN_Register":"580a31c1","registracija":"1c8815eb","EN_SignIn":"34860f1e","EN_TermsAndConditions":"36d4a619","Instructions":"eba74b4c","Vsa":"bd8e01a7","admin":"d9bd8efc","admin_nazorna_plosca":"46805ba9","app_protected":"0bbd7792","app_protected_moji_zapisi":"1796e3ef","chunk-34c17ba0":"cf4e2818","chunk-47285fac":"7ea0fe5d","chunk-4e9a73f2":"c2b4caa3","chunk-841efdac":"5db7adc8","o_projektu":"44847dcc","pogoji_uporabe":"189973ac","prijava":"17f0754b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"EN_EditPost~app_protected_zapis":1,"EN_EditPost":1,"app_protected_zapis":1,"admin_sponsors":1,"EN_Instructions":1,"EN_Post~zapis":1,"EN_TermsAndConditions":1,"Instructions":1,"Vsa":1,"admin_nazorna_plosca":1,"chunk-34c17ba0":1,"chunk-47285fac":1,"chunk-4e9a73f2":1,"chunk-841efdac":1,"pogoji_uporabe":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"EN_About":"EN_About","EN_EditPost~EN_MyProfile~admin_content_editor~admin_sponsors~admin_users~app_protected_moj_profil~ap~9952ae35":"EN_EditPost~EN_MyProfile~admin_content_editor~admin_sponsors~admin_users~app_protected_moj_profil~ap~9952ae35","EN_EditPost~app_protected_zapis":"EN_EditPost~app_protected_zapis","EN_EditPost":"EN_EditPost","app_protected_zapis":"app_protected_zapis","EN_MyProfile":"EN_MyProfile","admin_content_editor":"admin_content_editor","admin_sponsors":"admin_sponsors","admin_users":"admin_users","app_protected_moj_profil":"app_protected_moj_profil","EN_Home":"EN_Home","EN_Instructions":"EN_Instructions","EN_MyPosts":"EN_MyPosts","EN_Post~zapis":"EN_Post~zapis","EN_Post":"EN_Post","zapis":"zapis","EN_Register~registracija":"EN_Register~registracija","EN_Register":"EN_Register","registracija":"registracija","EN_SignIn":"EN_SignIn","EN_TermsAndConditions":"EN_TermsAndConditions","Instructions":"Instructions","Vsa":"Vsa","admin":"admin","admin_nazorna_plosca":"admin_nazorna_plosca","app_protected":"app_protected","app_protected_moji_zapisi":"app_protected_moji_zapisi","o_projektu":"o_projektu","pogoji_uporabe":"pogoji_uporabe","prijava":"prijava"}[chunkId]||chunkId) + "." + {"EN_About":"31d6cfe0","EN_EditPost~EN_MyProfile~admin_content_editor~admin_sponsors~admin_users~app_protected_moj_profil~ap~9952ae35":"31d6cfe0","EN_EditPost~app_protected_zapis":"9ffabda0","EN_EditPost":"374b9d2a","app_protected_zapis":"a62f458a","EN_MyProfile":"31d6cfe0","admin_content_editor":"31d6cfe0","admin_sponsors":"8daeed29","admin_users":"31d6cfe0","app_protected_moj_profil":"31d6cfe0","EN_Home":"31d6cfe0","EN_Instructions":"d7d31165","EN_MyPosts":"31d6cfe0","EN_Post~zapis":"b23ba9d3","EN_Post":"31d6cfe0","zapis":"31d6cfe0","EN_Register~registracija":"31d6cfe0","EN_Register":"31d6cfe0","registracija":"31d6cfe0","EN_SignIn":"31d6cfe0","EN_TermsAndConditions":"3a5c2e5f","Instructions":"8696c00c","Vsa":"da2f1392","admin":"31d6cfe0","admin_nazorna_plosca":"5b7a2968","app_protected":"31d6cfe0","app_protected_moji_zapisi":"31d6cfe0","chunk-34c17ba0":"d086fa4a","chunk-47285fac":"049896cd","chunk-4e9a73f2":"049896cd","chunk-841efdac":"880e2b77","o_projektu":"31d6cfe0","pogoji_uporabe":"7b2a6b1f","prijava":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
